import { httpClient } from '../../httpClient/httpClient';

export interface TemplateRangeTier {
  id: number;
  name: string;
  startRange: number;
  endRange: number;
  costMultiplier: number;
  archived: string | null;
}

export interface CreateTemplateRangeTierRequest {
  name: string;
  startRange: number;
  endRange: number;
  costMultiplier: number;
}

interface SearchQuery {
  searchTerm: string;
  includeArchived: boolean;
}

export type UpdateTemplateRangeTierRequest = CreateTemplateRangeTierRequest;

export const templateRangeTiersApi = {
  get: (id: number) =>
    httpClient.get<TemplateRangeTier>(`metadata/template-range-tiers/${id}`),
  getAll: (params: SearchQuery) =>
    httpClient.get<TemplateRangeTier[]>(`metadata/template-range-tiers/all`, {
      params,
    }),
  create: (request: CreateTemplateRangeTierRequest) =>
    httpClient.post<TemplateRangeTier>(`metadata/template-range-tiers`, {
      data: request,
    }),
  update: (id: number, request: UpdateTemplateRangeTierRequest) =>
    httpClient.put<TemplateRangeTier>(`metadata/template-range-tiers/${id}`, {
      data: request,
    }),
  archive: (id: number) =>
    httpClient.put(`metadata/template-range-tiers/${id}/archive`),
  restore: (id: number) =>
    httpClient.put(`metadata/template-range-tiers/${id}/restore`),
};
